module.exports = __webpack_public_path__ + "static/media/image-not-available.92a4fa5c.jpg";